import React from "react";
import styled from "styled-components";
import theme from "@/foundation/Theme";
import { FlexDiv } from "@/components/Atoms/Box";
import CheckBox from "@/components/Atoms/Inputs/CheckBox";
import {
  TextInput,
  PhoneInput,
  InputError,
  SubmitButton,
  Dropdown,
  TagGroup,
} from "@/components/Organisms/FormInputs";
import { SubmitButtonV2 } from "@/components/Organisms/FormInputs/ActionButtons/V2";

const DiagnosticRegisterForm = (props: any) => {
  const {
    isLoading = false,
    showLabels = true,
    id,
    error,
    onSubmitButtonClick,
    marginBottom,
    handleBlur = () => {},
    handleChange = () => {},
    handleSelectChange = () => {},
    showGoalsField,
    goalPlaceholder,
    goalOptions,
    goal,
    onGoalChange,
    goalError,
    showServicesField,
    serviceList,
    serviceLabel,
    selectedServiceIndex,
    onServiceChange,
    serviceError,
    name,
    nameError,
    namePlaceholder,
    phonePlaceholder,
    mobile,
    countryCode,
    mobileError,
    showEmailField,
    email,
    emailError,
    emailPlaceholder,
    buttonText,
    buttonPadding,
    variant = "v2",
    nameIcon = "icon-user-face-2",
    inputBorderRadius = "10px",
    focusable = false,
    homePageButton = false,
    goalLabel = "Health Condition",
    isAllInputsFilled,
    dropdownDisable = false,
    nameLabel = "Full Name",
    phoneLabel = "Phone",
    emailLabel = "Email",
    showLocation,
    locationPlaceHolder = "Your city",
    location,
    locationError,
    locationLabel = "Location (City)",
    pinCodeError,
    pinCode,
    showPinCode,
    pinCodePlaceHolder = "Pincode",
    pinCodeLabel = "Pincode",
    checkboxLabelText = "I agree to Metropolis Terms & Conditions and Privacy Policy",
    checkBoxVariant = "paragraph2",
    chkId = undefined,
    handleCheckBoxChange,
    termsCondition,
  } = props || {};

  return (
    <BodyWrap className="callback-form-containers" width="100%" flex={1}>
      <FlexDiv flexDirection="column" width="100%">
        {error && (
          <FlexDiv mb="8px">
            <InputError isNotAbsolute error={error} />
          </FlexDiv>
        )}
        <FormBox onSubmit={(e) => e.preventDefault()}>
          {showGoalsField && (
            <Dropdown
              name="goal"
              mb={marginBottom}
              placeholder={goalPlaceholder}
              options={goalOptions}
              value={goal}
              onChange={onGoalChange}
              error={goalError}
              variant={variant}
              goalLabel={goalLabel}
              isDisabled={dropdownDisable}
              dropDownWidth={"100%"}
            />
          )}
          {showServicesField && (
            <TagGroup
              tagList={serviceList}
              label={serviceLabel}
              selectedIndex={selectedServiceIndex}
              onClick={onServiceChange}
              error={serviceError}
              color={theme.colorsV2.gray.shade_500}
              activeColor={theme.colorsV2.shyft.purple_text}
              labelColor={theme.colorsV2.gray.shade_400}
            />
          )}
          <TextInput
            mb={marginBottom}
            showLabels={showLabels}
            reference={props.forwardedRef}
            name="name"
            icon={nameIcon}
            placeholder={namePlaceholder}
            value={name}
            onChange={handleChange}
            onBlur={handleBlur}
            error={nameError}
            required
            variant={variant}
            inputBorderRadius={inputBorderRadius}
            focusable={focusable}
            nameLabel={nameLabel}
          />
          {showEmailField && (
            <TextInput
              mb={marginBottom}
              showLabels={showLabels}
              reference={props.forwardedRef}
              placeholder={emailPlaceholder}
              name="email"
              type="email"
              icon="icon-EnvelopeSimple"
              value={email}
              onChange={handleChange}
              onBlur={handleBlur}
              error={emailError}
              required
              inputBorderRadius={inputBorderRadius}
              variant={variant}
              nameLabel={emailLabel}
              focusable={focusable}
            />
          )}
          <PhoneInput
            mb={marginBottom}
            showLabels={showLabels}
            reference={props.forwardedRef}
            placeholder={phonePlaceholder}
            value={mobile}
            onChange={handleChange}
            handleSelectChange={handleSelectChange}
            onBlur={handleBlur}
            error={mobileError}
            countryCode={countryCode}
            required
            variant={variant}
            focusable={focusable}
            inputBorderRadius={inputBorderRadius}
            phoneLabel={phoneLabel}
          />
          {showLocation && (
            <TextInput
              mb={marginBottom}
              showLabels={showLabels}
              reference={props.forwardedRef}
              name="location"
              icon={""}
              placeholder={locationPlaceHolder}
              value={location}
              onChange={handleChange}
              onBlur={handleBlur}
              error={locationError}
              required
              variant={variant}
              inputBorderRadius={inputBorderRadius}
              focusable={focusable}
              nameLabel={locationLabel}
            />
          )}
          {showPinCode && (
            <TextInput
              mb={marginBottom}
              showLabels={showLabels}
              reference={props.forwardedRef}
              name="pinCode"
              icon={""}
              placeholder={pinCodePlaceHolder}
              value={pinCode}
              onChange={handleChange}
              onBlur={handleBlur}
              error={pinCodeError}
              required
              variant={variant}
              inputBorderRadius={inputBorderRadius}
              focusable={focusable}
              nameLabel={pinCodeLabel}
            />
          )}
          <VerifyCheckBox
            m={"0 0 16px 0"}
            labelText={checkboxLabelText}
            variant={checkBoxVariant}
            id={chkId}
            name="termsCondition"
            handleCheckClick={handleCheckBoxChange}
            isChecked={termsCondition}
          />
          {homePageButton ? (
            <SubmitButtonV2
              mt={"16px"}
              buttonPadding={buttonPadding}
              onClick={onSubmitButtonClick}
              disabled={isLoading || !isAllInputsFilled()}
              id={id}
              isLoading={isLoading}
            >
              {buttonText}
            </SubmitButtonV2>
          ) : (
            <SubmitButton
              mt={marginBottom}
              buttonPadding={buttonPadding}
              onClick={onSubmitButtonClick}
              disabled={isLoading}
              id={id}
              isLoading={isLoading}
            >
              {buttonText}
            </SubmitButton>
          )}
        </FormBox>
      </FlexDiv>
    </BodyWrap>
  );
};

export default DiagnosticRegisterForm;

const BodyWrap = styled(FlexDiv)``;

const FormBox = styled.form`
  max-width: 100%;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
`;
const VerifyCheckBox = styled(CheckBox)``;
